import React from 'react'
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import { Switch, Route, Link, useHistory } from 'react-router-dom'
import useNotifications from 'hooks/useNotifications'
import ListadoClientes from 'sections/ListadoClientes/ListadoClientes'
import ClientesConectados from 'sections/ClientesConectados/ClientesConectados'
import TicketingList from 'sections/Ticketing/'
import TicketEdit from 'sections/Ticketing/Edit/TicketEdit'
import SpecialRequests from 'sections/SpecialRequest/SpecialRequests'
import FichaCliente from '../FichaCliente/FichaCliente'
import CollapseListItem from './CollapseListItem'
import logoClassfy from './resources/logoClassfy.png'
import { dashboardOptions } from './constants'
import styles from './Dashboard.module.css'

const countKey = {
  [dashboardOptions.top.SpecialRequests.to]: 'specialRequestCount'
}

function makeTitle({ title, showCount, count }) {
  if (!showCount || !count) return title
  return title + ` (${count})`
}

const Dashboard = () => {
  const { location } = useHistory()
  const notifications = useNotifications()
  return (
    <>
      <Drawer classes={{ paper: styles.drawer }} variant='permanent'>
        {Object.keys(dashboardOptions).map(key => {
          const items = dashboardOptions[key]
          return (
            <List
              key={key}
              className={key === 'bottom' ? styles.bottom_items : ''}
              style={{ padding: 0 }}
            >
              {Object.keys(items).map(itemKey => {
                const { to, icon, title, showCount, isCollapse, options } =
                  items[itemKey]
                if (
                  process.env.REACT_APP_HIDE_MENU_ITEMS?.split(',').includes(to)
                )
                  return null
                const selected =
                  location.pathname.split('/')[1] === to.split('/')[1]
                if (isCollapse)
                  return (
                    <CollapseListItem
                      key={itemKey}
                      title={title}
                      icon={icon}
                      options={options}
                      selected={selected}
                    />
                  )
                return (
                  <Link key={itemKey} className={styles.link} to={to}>
                    <ListItem button selected={selected} title={title}>
                      <ListItemIcon className={styles.icon}>
                        <i className='material-icons'>{icon}</i>
                      </ListItemIcon>
                      <ListItemText
                        className={styles.text}
                        primary={makeTitle({
                          title,
                          showCount,
                          count: notifications[countKey[to]] || 0
                        })}
                      />
                    </ListItem>
                  </Link>
                )
              })}
            </List>
          )
        })}
      </Drawer>
      <div className={styles.area}>
        <Switch>
          <Route
            exact
            path='/'
            component={() => (
              <div className={styles.dashboard_logo}>
                <img
                  className={styles.logo_classfy}
                  src={logoClassfy}
                  alt='classfy-logo'
                />
              </div>
            )}
          />
          <Route exact path='/clients' component={ListadoClientes} />
          <Route exact path='/clients/:id' component={FichaCliente} />
          <Route
            exact
            path='/online/connections'
            component={ClientesConectados}
          />
          <Route exact path='/ticketing' component={TicketingList} />
          <Route exact path='/ticketing/:id' component={TicketEdit} />
          <Route exact path='/special-requests' component={SpecialRequests} />
        </Switch>
      </div>
    </>
  )
}

export default Dashboard
